import Vue              from "vue";
import VueRouter        from "vue-router";
import AuthGuard        from "./authCheck";
import Login            from "../components/Auth/Login.vue";
import ProjectsList     from "../components/Projects/ProjectsList.vue";
import ProjectView      from "../components/Projects/ProjectView.vue";
import ProjectsEmpty    from "../components/Projects/ProjectsEmpty.vue";
import ProjectShared    from "../components/Projects/ProjectShared.vue";
import ProjectPShared   from "../components/Projects/ProjectPShared.vue";
import ProjectsNoData   from "../components/Projects/ProjectsNoData.vue";
import ProjectsTrash    from "../components/Projects/ProjectsTrash.vue";
import NotFound         from "../components/NotFound.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Home Page",
        component: ProjectsEmpty,
        beforeEnter: AuthGuard
    },{
        path: "/trash",
        name: "Trash Page",
        component: ProjectsTrash,
        beforeEnter: AuthGuard
    },{
        path: "/login",
        name: "Login Page",
        component: Login
    },{
        path: "/projects/:id",
        props: true,
        name: "Projects Page",
        component: ProjectsList,
        beforeEnter: AuthGuard
    },{
        path: "/view/:project_id/:layer_id",
        props: true,
        name: "View Page",
        component: ProjectView,
        beforeEnter: AuthGuard
    },{
        path: "/share/:project_id",
        props: true,
        name: "Shared Page",
        component: ProjectShared
    },{
        path: "/pshare/:project_id",
        props: true,
        name: "Pass Shared Page",
        component: ProjectPShared
    },{
        path: "/no_data",
        name: "No Data Page",
        component: ProjectsNoData
    },{
        path: '/404',
        name: "404 Page",
        component: NotFound
    },{
        path: '*',
        name: "Default Page",
        redirect: '/404',
        beforeEnter: AuthGuard
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;
